<template>
  <delivery-firms-shell v-if="useNewView" @legacy="openLegacy" />
  <delivery-legacy v-else @new-view="openNewView" />
</template>

<script>
import DeliveryLegacy from "./DeliveryLegacy.vue";
import DeliveryFirmsShell from "@/components/delivery-firms-shell/DeliveryFirmsShell.vue";
import { FIRMS_QUERY, LEGACY_UI_VALUE } from "@/components/delivery-firms-shell/firmsQuery";

/**
 * Firme za dostavu (/firmeDostava) imaju novi izgled kao izvještaji, magacin, recepti, finansije i korisnici dostave;
 * ?ui=stari vraća staru stranicu (DeliveryLegacy).
 */
export default {
  name: "CompanyDelivery",
  components: { DeliveryLegacy, DeliveryFirmsShell },
  computed: {
    useNewView() {
      return this.$route.query[FIRMS_QUERY.legacy] !== LEGACY_UI_VALUE;
    },
  },
  methods: {
    openLegacy() {
      this.$router.replace({ query: { ...this.$route.query, [FIRMS_QUERY.legacy]: LEGACY_UI_VALUE } }).catch(() => {});
    },
    openNewView() {
      const query = { ...this.$route.query };
      delete query[FIRMS_QUERY.legacy];
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
